export default function MailTo({ href, children }) {
    return <a href={`mailto:${href}`}>{children || href}</a>;
}
